import { api } from "../api/api";

const errorHandler = (error) => {
  if (error?.code?.trim() == "ERR_NETWORK") {
    throw new Error(
      "It looks like we can't reach the server right now. Please try refreshing the page or check after sometime."
    );
  } else {
    throw new Error(error?.response?.data?.title);
  }
};

export const getRegionMappings = async (params) => {
  try {
    const response = await api.get("/api/ediPurchaseOrder/regionMappings", {
      params
    });

    return response.data?.result?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const autoToggleRegionMapping = async (params) => {
  try {
    const response = await api.post(
      `/api/ediPurchaseOrder/regionMappings/automation?regionMappingId=${params.regionMappingId}&isAutomated=${params.isAutomated}`
    );

    return response.data?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const approveRegionMappings = async (payload) => {
  try {
    const response = await api.post(
      "/api/ediPurchaseOrder/regionMappings/approve",
      payload
    );
    return response.data?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const deleteRegionMappings = async (payload) => {
  try {
    const response = await api.post(
      "/api/ediPurchaseOrder/regionMappings/delete",
      payload
    );
    return response.data?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const createRegionMapping = async (payload) => {
  try {
    const response = await api.post(
      "/api/ediPurchaseOrder/regionMappings/create",
      payload
    );
    return response.data?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};
